<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,12C15,12,3.12,12,3.12,12C3.12,12,4.93,10.61,4.93,10.61C6.66,11.62,10.46,10.58,14.01,8C14.01,8,12.79,6.5,12.79,6.5C10.3,8.3,7.86,9.370000000000001,6.65,9.29C6.65,9.29,14.3,3.4,14.3,3.4C14.3,3.4,13.7,2.6,13.7,2.6C13.7,2.6,5.87,8.629999999999999,5.87,8.629999999999999C5.86,7.56,7.67,5.4399999999999995,10.34,3.5C10.34,3.5,9.12,2.000000000000001,9.12,2.000000000000001C5.38,4.7,3.34,8.1,4.25,9.870000000000001C4.25,9.870000000000001,2,11.6,2,11.6C2,11.6,2,3,2,3C2,2.45,1.55,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CurvedRangeChart',
} as DefineComponent
</script>
